import { render, staticRenderFns } from "./CenteredText.vue?vue&type=template&id=6029fe76&scoped=true&"
import script from "./CenteredText.vue?vue&type=script&lang=js&"
export * from "./CenteredText.vue?vue&type=script&lang=js&"
import style0 from "./CenteredText.vue?vue&type=style&index=0&id=6029fe76&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6029fe76",
  null
  
)

export default component.exports